export default {
  GLOBAL: 'global',
  SKIP_WAITING: 'SKIP_WAITING',
  UPDATE_AVAILABLE: 'UPDATE_AVAILABLE',
};
